import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { DepartmentDocument, departmentPullQueryBuilder } from './queryBuilder';

export function departmentFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<DepartmentDocument> {
  const syncConfig = configBuilder<DepartmentDocument>(RxdbCollectionNameV2.DEPARTMENT);
  doNotAutoSync(syncConfig);

  pull(syncConfig, departmentPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.DEPARTMENT, replicationState, [sites]);
}
